<template>
  <vue-scroll class="page-calendar">
    <el-row>
      <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
        <el-tab-pane label="Calendarios" name="calendar">
          <div v-loading="calendarLoading">
            <el-alert
              v-if="rulesForShowingAlert"
              style="margin-bottom: 10px"
              title="No tiene permiso para editar este calendario, no podrá guardar cambios"
              type="warning"
              center
              show-icon
            >
            </el-alert>
            <el-row v-if="currentChosenCalendarID > 0">
              <el-col :span="20" :offset="1" v-if="currentChosenCalendarID > 0">
                <h2 style="margin: auto; text-align: center">
                  {{ calendarTitle }}
                </h2>
              </el-col>
            </el-row>
            <el-row
              v-if="currentChosenCalendarID > 0"
              type="flex"
              justify="space-between"
              :gutter="10"
            >
              <!-- Calendar Title -->

              <el-col :span="17">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="12">
                        <span class="textBold">{{ GetExecutedLabel }}</span>
                      </el-col>
                      <el-col :span="12">
                        <el-input
                          size="small"
                          :value="GetExecutedInvPay"
                          :label="GetExecutedLabel"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="8">
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="12">
                        <span class="textBold">{{ GetPendingLabel }}</span>
                      </el-col>
                      <el-col :span="12">
                        <el-input
                          size="small"
                          :value="GetPendingInvPay"
                          :label="GetPendingLabel"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>

                <el-row v-if="currentChosenCalendarID > 0" :gutter="20">
                  <el-col :span="8">
                    <!-- <el-row class="rowTotals">
                      <el-col :span="12">
                        <span class="textBold">{{ PayOneQuinceLabel }}</span>
                      </el-col>
                      <el-col :span="12">
                        <el-input
                          size="small"
                          :value="PayOneQuinceInvPay"
                          :label="PayOneQuinceLabel"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row>
                    <el-row class="rowTotals">
                      <el-col :span="12">
                        <span class="textBold">{{ PaySecondQuinceLabel }}</span>
                      </el-col>
                      <el-col :span="12">
                        <el-input
                          size="small"
                          :value="PaySecondQuinceInvPay"
                          :label="PaySecondQuinceLabel"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row> -->
                    <el-row
                      class="rowTotals"
                      :gutter="10"
                      type="flex"
                      justify="end"
                    >
                      <el-col :span="12">
                        <span class="textBold">Pagos</span>
                      </el-col>
                    </el-row>
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="12">
                        <span class="textBold"> Semana 1 </span>
                      </el-col>
                      <el-col :span="12">
                        <el-input
                          size="small"
                          :value="GetPaymentFirstWeekInvPay"
                          :label="GetPaymentFirstWeekLabel"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row>
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="12">
                        <span class="textBold"> Semana 2 </span>
                      </el-col>
                      <el-col :span="12">
                        <el-input
                          size="small"
                          :value="GetPaymentSecondWeekInvPay"
                          :label="GetPaymentSecondWeekLabel"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row>
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="12">
                        <span class="textBold">Semana 3</span>
                      </el-col>
                      <el-col :span="12">
                        <el-input
                          size="small"
                          :value="GetPaymentThirdWeekInvPay"
                          :label="GetPaymentThirdWeekLabel"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row>
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="12">
                        <span class="textBold"> Semana 4 </span>
                      </el-col>
                      <el-col :span="12">
                        <el-input
                          size="small"
                          :value="GetPaymentFourthWeekInvPay"
                          :label="GetPaymentFourthWeekLabel"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row>
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="12">
                        <span class="textBold"> Semana 5 </span>
                      </el-col>
                      <el-col :span="12">
                        <el-input
                          size="small"
                          :value="GetPaymentFifthWeekInvPay"
                          :label="GetPaymentFifthWeekLabel"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row>
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="12">
                        <span class="textBold">Totales</span>
                      </el-col>

                      <el-col :span="12">
                        <el-input
                          size="small"
                          :value="GetTotalInvPay"
                          :label="GetTotalLabel"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="4">
                    <!--cobros-->
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="24">
                        <span class="textBold">Cobrado</span>
                      </el-col>
                    </el-row>
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="24">
                        <el-input
                          size="small"
                          :value="GetCollectionFirstWeekInvPay"
                          :label="GetCollectionFirstWeekLabel"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row>
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="24">
                        <el-input
                          size="small"
                          :value="GetCollectionSecondWeekInvPay"
                          :label="GetCollectionSecondWeekLabel"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row>
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="24">
                        <el-input
                          size="small"
                          :value="GetCollectionThirdWeekInvPay"
                          :label="GetCollectionThirdWeekLabel"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row>
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="24">
                        <el-input
                          size="small"
                          :value="GetCollectionFourthWeekInvPay"
                          :label="GetCollectionFourthWeekLabel"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row>
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="24">
                        <el-input
                          size="small"
                          :value="GetCollectionFifthWeekInvPay"
                          :label="GetCollectionFifthWeekLabel"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row>
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="24">
                        <el-input
                          size="small"
                          :value="GetTotalCollectionInvPay"
                          :label="GetTotalCollectionLabel"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="8">
                    <!-- <el-row style="margin-bottom: 2em" :gutter="10"> </el-row> -->
                    <!--Diferencia Cobrado menos Pagos-->
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="12">
                        <span class="textBold">Diferencia</span>
                      </el-col>
                    </el-row>
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="12">
                        <el-input
                          :class="ClassObjectFirstWeek"
                          size="small"
                          :value="DifferenceFirstWeekValue"
                          :label="DifferenceFirstWeekLabel"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row>
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="12">
                        <el-input
                          :class="ClassObjectSecondWeek"
                          size="small"
                          :value="DifferenceSecondWeekValue"
                          :label="DifferenceSecondWeekLabel"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row>
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="12">
                        <el-input
                          :class="ClassObjectThirdWeek"
                          size="small"
                          :value="DifferenceThirdWeekValue"
                          :label="DifferenceThirdWeekLabel"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row>
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="12">
                        <el-input
                          :class="ClassObjectFourthWeek"
                          size="small"
                          :value="DifferenceFourthWeekValue"
                          :label="DifferenceFourthWeekLabel"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row>
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="12">
                        <el-input
                          :class="ClassObjectFifthWeek"
                          size="small"
                          :value="DifferenceFifthWeekValue"
                          :label="DifferenceFifthWeekLabel"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row>
                    <el-row class="rowTotals" :gutter="10">
                      <el-col :span="12">
                        <el-input
                          :class="ClassObjectTotalWeek"
                          size="small"
                          :value="DifferenceTotalValue"
                          :label="TotalDIfference"
                          disabled
                        ></el-input>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :offset="1" :span="7">
                <el-row type="flex" justify="end">
                  <el-col :span="19" style="text-align: right">
                    <el-avatar size="large">
                      <img :src="RespImgUrl" />
                    </el-avatar>
                  </el-col>
                  <el-col :span="5"></el-col>
                </el-row>

                <el-row type="flex" justify="end">
                  <el-col :span="19" style="text-align: right">
                    <span class="boldedWord">{{ RespName }}</span>
                  </el-col>
                  <el-col :offset="1" :span="5">
                    <el-tooltip content="Cambiar Responsable">
                      <el-button
                        type="info"
                        size="mini"
                        @click="ChangeCalendarResponsible"
                        icon="el-icon-refresh"
                      ></el-button>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="end"> </el-row>
              </el-col>
            </el-row>
            <!--Total Amounts for Header-->

            <el-row>
              <!-- Calendar Dropdown -->
              <el-col :span="3">
                <div class="flex justify-space-between mb-5">
                  <div class="box">
                    <el-select
                      v-model="currentChosenCalendarID"
                      placeholder="Calendario"
                      size="mini"
                      filterable
                      clearable
                    >
                      <el-option
                        v-for="item in listOfCalendarsForUser"
                        :key="item.ID"
                        :label="item.Title"
                        :value="item.ID"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </el-col>
              <el-col :offset="5" :span="4" v-if="currentChosenCalendarID > 0">
                <InvoiceType
                  :initialValue="invoiceType"
                  :isClearable="true"
                  inputSize="mini"
                  @OnInvoiceTypeSelected="OnInvoiceTypeSelected"
                />
              </el-col>

              <!-- <el-col :span="3">
                    <el-button
                      size="mini"
                      plain
                      @click="openCalendarDialog"
                      v-if="
                        this.currentUser.PositionID == 16 || //CEO
                        this.currentUser.PositionID == 47 || //GERENTE DE TI
                        this.currentUser.PositionID == 82 || // GERENTE DE OPERACIONES Y PROYECTOS
                        this.currentUser.PositionID == 68
                      "
                    >
                      ✚</el-button
                    >
                  </el-col> -->

              <!-- <el-col :offset="4" style="margin: auto; text-align: center">
                    <el-form :inline="true" class="demo-form-inline">
                      <el-form-item label="Monto total:">
                        <el-input v-model="amountTotal" disabled></el-input>
                      </el-form-item>

                      <el-form-item label="Cantidad de registros:">
                        <el-input v-model="recordsTotal" disabled></el-input>
                      </el-form-item>
                    </el-form>
                  </el-col> -->
            </el-row>

            <!-- Calendar -->
            <el-row>
              <el-col :span="24" v-if="currentChosenCalendarID > 0">
                <FullCalendar
                  ref="fullCalendar"
                  :options="config"
                  class="calendar-wrap card-base card-shadow--medium"
                  @viewDisplay="onCalendarViewChange"
                />
              </el-col>
              <el-col :span="10" v-else class="text-center">
                <h1>
                  <i class="el-icon-top"></i>Debe seleccionar un calendario
                </h1>
              </el-col>
            </el-row>
          </div>

          <!--CHange calendar responsible dialog-->
          <ChangeCalendarResponsible
            :showResponsibleChanger="showResponsibleChanger"
            :CurrentResponsableInfo="CurrentResponsableInfo"
            :CurrentCalendarInfo="CurrentCalendarInfo"
            @OnChangeCalendarclose="OnChangeCalendarclose"
            @CalendarResponsibleUpdated="CalendarResponsibleUpdated"
          />

          <!-- Event Create Dialog -->
          <CalendarFinancesEventForm
            ref="form"
            @close-event-dialog="closeEventDialog"
            :form="form"
            :submitMode="submitMode"
            :dialogFormVisible="dialogFormVisible"
            :rulesForDisablingSaveButton="rulesForDisablingSaveButton"
            :rulesForDisablingDelete="rulesForDisablingDelete"
            :eventSelectedIsTask="eventSelectedIsTask"
            :userIsSupervisor="userIsSupervisor"
            :userId="userId"
            :currentlyChosenAgenda="currentlyChosenAgenda"
            :currentChosenCalendarID="currentChosenCalendarID"
            :CurrentResponsableInfo="CurrentResponsableInfo"
          />

          <!-- Calendar Create Dialog -->
          <el-dialog
            title="Crear Calendario"
            :visible.sync="calendarFormVisible"
          >
            <el-form
              :model="calendarForm"
              ref="calendarForm"
              label-position="top"
            >
              <el-form-item
                label="Titulo"
                prop="title"
                :rules="[
                  {
                    required: true,
                    message: 'El titulo es requerido',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input
                  v-model="calendarForm.title"
                  :disabled="eventSelectedIsTask"
                ></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="closeCalendarDialog" v-loading="loading"
                >Cancel</el-button
              >
              <el-button
                type="primary"
                @click="submitCalendar"
                v-loading="loading"
                >Save</el-button
              >
            </span>
          </el-dialog>

          <!-- Calendar Share Drawer -->
          <ShareCalendarDrawer
            :openDrawer="openDrawer"
            :calendarID="currentChosenCalendarID"
            @close-drawer="handleCloseDrawer"
          />
        </el-tab-pane>
        <el-tab-pane label="Reporte" name="report">
          <el-row>
            <PaymentAndInvoicingReport :TabSelected="activeTabName" />
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-row>
  </vue-scroll>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import allLocales from "@fullcalendar/core/locales-all";
import momentPlugin from "@fullcalendar/moment";

import { formatArrayToElSelect, formatMonto } from "@/utils";
import ShareCalendarDrawer from "@/components/calendar/ShareCalendarDrawer";
import CalendarFinancesEventForm from "@/components/calendar/CalendarFinancesEventForm";
// import { formatMonto } from "@/utils";
import ChangeCalendarResponsible from "@/views/apps/calendar/ChangeCalendarResponsible.vue";
import PaymentAndInvoicingReport from "@/components/fiances/reports/PaymentAndInvoicingReport";
import InvoiceType from "@/components/calendar/selectors/InvoiceType";

export default {
  name: "CalendarFinances",
  components: {
    FullCalendar,
    CalendarFinancesEventForm,
    ShareCalendarDrawer,
    ChangeCalendarResponsible,
    PaymentAndInvoicingReport,
    InvoiceType
  },
  data() {
    return {
      recordsTotal: this.$store.getters["calendarFinances/events"].length,
      amountTotal: 0,
      employees: [],
      employeeId: 0,
      userId: 0,
      currentChosenCalendarID: 2,
      RespImgUrl: "",
      RespName: "",
      loading: false,
      calendarApi: null,
      dialogFormVisible: false,
      submitMode: "", // Will be "Add" or "Edit"
      currentlyChosenAgenda: {},
      showResponsibleChanger: false,
      CurrentResponsableInfo: {},
      CurrentCalendarInfo: {},
      CalendarTotalSumaries: [],
      CollectionByWeek: [],
      TotalLabel: "",
      TotalInvPay: 0,
      ExecutedLabel: "",
      ExecutedInvPay: 0,
      PendingLabel: "",
      PendingInvPay: 0,
      PayOneQuinceLabel: "",
      PayOneQuinceInvPay: 0,
      PaySecondQuinceLabel: "",
      PaySecondQuinceInvPay: 0,
      PaymentFirstWeekLabel: "",
      PaymentFirstWeekInvPay: 0,
      PaymentSecondWeekLabel: "",
      PaymentSecondWeekInvPay: 0,
      PaymentThirdWeekLabel: "",
      PaymentThirdWeekInvPay: 0,
      PaymentFourthWeekLabel: "",
      PaymentFourthWeekInvPay: 0,
      PaymentFifthWeekLabel: "",
      PaymentFifthWeekInvPay: 0,
      CollectionFirstWeekLabel: "",
      CollectionFirstWeekInvPay: 0,
      CollectionSecondWeekLabel: "",
      CollectionSecondWeekInvPay: 0,
      CollectionThirdWeekLabel: "",
      CollectionThirdWeekInvPay: 0,
      CollectionFourthWeekLabel: "",
      CollectionFourthWeekInvPay: 0,
      CollectionFifthWeekLabel: "",
      CollectionFifthWeekInvPay: 0,
      TotalCollectionLabel: "",
      TotalCollectionInvPay: 0,
      CalendarMonth: 0,
      CalendarYear: 0,
      activeTabName: "calendar",
      form: {
        title: "",
        description: "",
        allDay: true,
        paid: false,
        type: true,
        startDate: "",
        startTime: "",
        endDate: "",
        endDatePayment: "",
        amount: 0,
        endTime: "",
        agendaType: 0,
        color: "#F22727",
        Time: 2,
        minutesHours: "m",
        fixed: true,
        invoiceType: "",
        SerieGroup: null,
        editionSerie: ""
      },
      submitModeOptions: {
        Add: "Agregar Facturación y Fecha de Pago",
        Edit: "Editar Fecha de Facturación",
        AddPayment: "Agregar Fecha de Pago",
        EditPayment: "Editar Fecha de Pago"
      },
      predefineColors: [
        "#ff4500",
        "#ff8c00",
        "#ffd700",
        "#90ee90",
        "#00ced1",
        "#1e90ff",
        "#F56C6C",
        "#c71585"
      ],

      calendarFormVisible: false,
      calendarForm: {
        title: ""
      },
      calendarDeleteDialogVisible: false,
      openDrawer: false,
      invoiceType: ""
    };
  },
  async created() {
    this.employeeId = this.currentUser.EmployeeId;
    this.userId = this.currentUser.UserID;

    await this.GetPersonalCalendario({
      employeeID: this.employeeId,
      invoiceType: this.invoiceType
    }); // Creates personal calendar if it doesn't exist
    await this.getAllCalendarsForEmployee(this.employeeId);
    // this.setPersonalCalendarAsCurrentlyChosen();

    await this.loadEmployees();

    await this.ChangingCalendar(this.currentChosenCalendarID);
  },
  // async mounted() {
  //   await this.ChangingCalendar(this.currentChosenCalendarID);
  // },
  computed: {
    ...mapGetters("calendarFinances", [
      "events",
      "weekendsVisible",
      "eventsAreLoading",
      "tasksAreLoading",
      "getCalendarFPsInfo"
    ]),
    /*
    TotalLabel() {
      let label = ""
      if (this.currentChosenCalendarID === 1){
        label = "Total de Facturas"
      } else if (this.currentChosenCalendarID === 2) {
        label = "Total de Pagos"
      }
      return label
    },
    TotalInvPay(){
      let amount = ""
      if (this.currentChosenCalendarID === 1){
        amount = this.CalendarTotalSumaries.filter(item => item.Description === "TotalInvoices")[0].Amount
      } else if (this.currentChosenCalendarID === 2) {
        amount = this.CalendarTotalSumaries.filter(item => item.Description === "TotalPayments")[0].Amount
      }
      return amount
    },
    */
    // Calendar configuration
    config() {
      return {
        ...this.configOptions,
        ...this.eventHandlers
      };
    },

    configOptions() {
      return {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          listPlugin,
          interactionPlugin,
          momentPlugin
        ],
        initialView: "dayGridMonth",
        locales: allLocales,
        locale: "es", // the initial locale
        height: "auto",
        firstDay: 1,
        allDaySlot: true,
        slotEventOverlap: true,
        selectable: true,
        selectMirror: true,
        eventTimeFormat: {
          hour: "2-digit", //2-digit, numeric
          minute: "2-digit", //2-digit, numeric
          // second: "2-digit", //2-digit, numeric
          meridiem: true, //lowercase, short, narrow, false (display of AM/PM)
          hour12: false //true, false
        },
        navLinks: true, // can click day/week names to navigate views
        editable: true,
        durationEditable: false,
        dayMaxEventRows: true, // for all non-TimeGrid views # v5
        views: {
          month: {
            dayMaxEventRows: 5
          }
        },
        customButtons: {
          // addEvent: {
          //   text: this.calendarTitle == "Calendario de Facturación" ? this.submitModeOptions.Add : this.submitModeOptions.AddPayment,
          //   click: this.addEventDialog
          // }
          //this is only for the calendar Calendario de Facturación
          addEvent: {
            text:
              this.calendarTitle == "Calendario de Facturación"
                ? this.submitModeOptions.Add
                : null,
            click:
              this.calendarTitle == "Calendario de Facturación"
                ? this.addEventDialog
                : null
          },
          prev: {
            text: "Mes Anterior",
            click: this.OnPrevMonthClick
          },
          next: {
            text: "Mes Siguiente",
            click: this.OnNextMonthClick
          },
          today: {
            text: "Hoy",
            click: this.OnTodayMonthClick
          },
          prevYear: {
            text: "Año Anterior",
            click: this.OnPrevYearClick
          },
          nextYear: {
            text: "Año Siguiente",
            click: this.OnNextYearClick
          }
        },
        headerToolbar: {
          left: "prev,next today prevYear,nextYear",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek addEvent"
        },
        weekends: this.weekendsVisible,
        events: this.$store.getters["calendarFinances/events"]
      };
    },
    eventHandlers() {
      return {
        dateClick: this.onDateClick,
        eventClick: this.onEventClick,
        select: this.onDateSelect,
        eventDrop: this.onEventDrop
        //viewDisplay: this.onCalendarViewChange
      };
    },
    calendarTitle() {
      if (this.currentChosenCalendarID) {
        let calendar = this.listOfCalendarsForUser.find(
          (element) => element.ID == this.currentChosenCalendarID
        );
        return calendar ? calendar.Title : "-";
      } else {
        return "-";
      }
    },

    listOfCalendarsForUser() {
      return this.$store.getters["calendarFinances/calendarsForUser"];
    },

    calendarLoading() {
      return this.eventsAreLoading;
    },

    // Settings
    watchingSubordinatesCalendars() {
      // This is when the Employee dropdown is being used
      return this.employeeId != this.currentUser.EmployeeId;
    },
    userIsSupervisor() {
      return this.employees.length > 1; // Explanation: Only supervisor roles get the dropdown, if the dropdown exists then the employees property will have contents
    },
    calendarIsPersonal() {
      let listOfCalendars = this.listOfCalendarsForUser;
      return listOfCalendars.find(
        (cal) => cal.ID === this.currentChosenCalendarID && cal.isPersonal
      );
    },
    userCanEditCalendar() {
      let listOfCalendars = this.listOfCalendarsForUser;
      return listOfCalendars.find(
        (cal) => cal.ID === this.currentChosenCalendarID && cal.canEdit
      );
    },
    eventSelectedIsTask() {
      return this.currentlyChosenAgenda.event
        ? this.currentlyChosenAgenda.event.extendedProps.isTask
        : false;
    },

    // Rules and permissions
    rulesForShowingAlert() {
      if (this.currentChosenCalendarID > 0 && this.listOfCalendarsForUser) {
        // Si ya ha cargado la vista
        if (!this.userCanEditCalendar || this.watchingSubordinatesCalendars) {
          return true;
        }
      }

      return false;
    },
    rulesForDisablingSaveButton() {
      // Can't add or edit Agendas to a calendar that belongs to subordinates
      if (this.watchingSubordinatesCalendars) {
        if (!this.eventSelectedIsTask) {
          return true;
        }
      }
      // Non supervisors can't edit tasks
      if (this.eventSelectedIsTask && !this.userIsSupervisor) {
        return true;
      }
      // Can't edit if user doesn't have edit permission
      if (!this.userCanEditCalendar) {
        return true;
      }

      return false;
    },
    rulesForDisablingDelete() {
      return (
        this.watchingSubordinatesCalendars || // Can't delete elements from the calendar of a subordinate
        this.eventSelectedIsTask || // Can't delete tasks
        this.submitMode === this.submitModeOptions.Add || // Can't delete while adding
        this.submitMode === this.submitModeOptions.AddPayment || // Can't delete while adding
        !this.userCanEditCalendar // Can't delete without editing permission
      );
    },
    GetResponsibleImgUrl() {
      let imageUrl = this.RespImgUrl;

      return imageUrl;
    },
    GetTotalLabel() {
      return this.TotalLabel;
    },
    GetTotalInvPay() {
      return formatMonto(this.TotalInvPay);
    },
    GetExecutedLabel() {
      return this.ExecutedLabel;
    },
    GetExecutedInvPay() {
      return formatMonto(this.ExecutedInvPay);
    },
    GetPendingLabel() {
      return this.PendingLabel;
    },
    GetPendingInvPay() {
      return formatMonto(this.PendingInvPay);
    },
    GetPaymentFirstWeekLabel() {
      return this.PaymentFirstWeekLabel;
    },
    GetPaymentFirstWeekInvPay() {
      return formatMonto(this.PaymentFirstWeekInvPay);
    },
    GetPaymentSecondWeekLabel() {
      return this.PaymentSecondWeekLabel;
    },
    GetPaymentSecondWeekInvPay() {
      return formatMonto(this.PaymentSecondWeekInvPay);
    },
    GetPaymentThirdWeekLabel() {
      return this.PaymentThirdWeekLabel;
    },
    GetPaymentThirdWeekInvPay() {
      return formatMonto(this.PaymentThirdWeekInvPay);
    },
    GetPaymentFourthWeekLabel() {
      return this.PaymentFourthWeekLabel;
    },
    GetPaymentFourthWeekInvPay() {
      return formatMonto(this.PaymentFourthWeekInvPay);
    },
    GetPaymentFifthWeekLabel() {
      return this.PaymentFifthWeekLabel;
    },
    GetPaymentFifthWeekInvPay() {
      return formatMonto(this.PaymentFifthWeekInvPay);
    },
    GetCollectionFirstWeekLabel() {
      return this.CollectionFirstWeekLabel;
    },
    GetCollectionFirstWeekInvPay() {
      return formatMonto(this.CollectionFirstWeekInvPay);
    },
    GetCollectionSecondWeekLabel() {
      return this.CollectionSecondWeekLabel;
    },
    GetCollectionSecondWeekInvPay() {
      return formatMonto(this.CollectionSecondWeekInvPay);
    },
    GetCollectionThirdWeekLabel() {
      return this.CollectionThirdWeekLabel;
    },
    GetCollectionThirdWeekInvPay() {
      return formatMonto(this.CollectionThirdWeekInvPay);
    },
    GetCollectionFourthWeekLabel() {
      return this.CollectionFourthWeekLabel;
    },
    GetCollectionFourthWeekInvPay() {
      return formatMonto(this.CollectionFourthWeekInvPay);
    },
    GetCollectionFifthWeekLabel() {
      return this.CollectionFifthWeekLabel;
    },
    GetCollectionFifthWeekInvPay() {
      return formatMonto(this.CollectionFifthWeekInvPay);
    },
    GetTotalCollectionLabel() {
      return this.TotalCollectionLabel;
    },
    GetTotalCollectionInvPay() {
      return formatMonto(this.TotalCollectionInvPay);
    },
    DifferenceFirstWeekLabel() {
      return "Diferencia Semana 1";
    },
    DifferenceSecondWeekLabel() {
      return "Diferencia Semana 2";
    },
    DifferenceThirdWeekLabel() {
      return "Diferencia Semana 3";
    },
    DifferenceFourthWeekLabel() {
      return "Diferencia Semana 4";
    },
    DifferenceFifthWeekLabel() {
      return "Diferencia Semana 5";
    },
    TotalDIfference() {
      return "Diferencia Total";
    },
    DifferenceFirstWeekValue() {
      let difference =
        Number(this.CollectionFirstWeekInvPay) -
        Number(this.PaymentFirstWeekInvPay);

      return formatMonto(difference);
    },
    DifferenceSecondWeekValue() {
      let difference =
        Number(this.CollectionSecondWeekInvPay) -
        Number(this.PaymentSecondWeekInvPay);

      return formatMonto(difference);
    },
    DifferenceThirdWeekValue() {
      let difference =
        Number(this.CollectionThirdWeekInvPay) -
        Number(this.PaymentThirdWeekInvPay);

      return formatMonto(difference);
    },
    DifferenceFourthWeekValue() {
      let difference =
        Number(this.CollectionFourthWeekInvPay) -
        Number(this.PaymentFourthWeekInvPay);

      return formatMonto(difference);
    },
    DifferenceFifthWeekValue() {
      let difference =
        Number(this.CollectionFifthWeekInvPay) -
        Number(this.PaymentFifthWeekInvPay);

      return formatMonto(difference);
    },
    DifferenceTotalValue() {
      let difference =
        Number(this.TotalCollectionInvPay) - Number(this.TotalInvPay);

      return formatMonto(difference);
    },
    ClassObjectFirstWeek() {
      let difference =
        Number(this.CollectionFirstWeekInvPay) -
        Number(this.PaymentFirstWeekInvPay);
      return {
        IsRed: difference < 0
      };
    },
    ClassObjectSecondWeek() {
      let difference =
        Number(this.CollectionSecondWeekInvPay) -
        Number(this.PaymentSecondWeekInvPay);
      return {
        IsRed: difference < 0
      };
    },
    ClassObjectThirdWeek() {
      let difference =
        Number(this.CollectionThirdWeekInvPay) -
        Number(this.PaymentThirdWeekInvPay);
      return {
        IsRed: difference < 0
      };
    },
    ClassObjectFourthWeek() {
      let difference =
        Number(this.CollectionFourthWeekInvPay) -
        Number(this.PaymentFourthWeekInvPay);
      return {
        IsRed: difference < 0
      };
    },
    ClassObjectFifthWeek() {
      let difference =
        Number(this.CollectionFifthWeekInvPay) -
        Number(this.PaymentFifthWeekInvPay);
      return {
        IsRed: difference < 0
      };
    },
    ClassObjectTotalWeek() {
      let difference =
        Number(this.TotalCollectionInvPay) - Number(this.TotalInvPay);
      return {
        IsRed: difference < 0
      };
    }
  },
  methods: {
    ...mapActions("calendarFinances", [
      "create",
      "update",
      "set_weekends_visible",
      "GetPersonalCalendario",
      "initTasks",
      "updateTaskInApi",
      "delete",
      "getAllCalendarsForEmployee",
      "GetCalendario",
      "CreateCalendario",
      "DeleteCalendario"
    ]),

    findMyPersonalCalendar() {
      // Gets the personal calendar of the current user
      let listOfCalendars = this.listOfCalendarsForUser;
      let personalCalendar = listOfCalendars.find(
        (cal) => cal.isPersonal && cal.CreatedBy == this.employeeId
      );
      if (personalCalendar) {
        return personalCalendar.ID;
      } else {
        this.$message.error("Error al encontrar calendario");
      }
    },
    setPersonalCalendarAsCurrentlyChosen() {
      this.currentChosenCalendarID = this.findMyPersonalCalendar();
    },

    closeEventDialog() {
      // this.$refs.form.resetFields();
      this.dialogFormVisible = false;
      this.form = {
        title: "",
        description: "",
        allDay: false,
        paid: false,
        type: false,
        startDate: "",
        startTime: "",
        endDate: "",
        endDatePayment: "",
        amount: 0,
        endTime: "",
        color: "#F56C6C",
        agendaType: 0,
        Time: 2,
        minutesHours: "m",
        fixed: true,
        invoiceType: ""
      };

      this.GetCalendario({
        calendarioID: this.currentChosenCalendarID,
        invoiceType: this.invoiceType
      });
      if (this.calendarIsPersonal) {
        // If the calendar is personal, get the Tasks of the owner of that calendar
        let calendarCreator = this.listOfCalendarsForUser.find(
          (cal) => cal.ID == this.currentChosenCalendarID
        ).CreatedBy;
        this.initTasks(calendarCreator);
      }
    },

    addEventDialog() {
      if (this.userCanEditCalendar || this.userIsSupervisor) {
        if (this.calendarTitle == "Calendario de Facturación") {
          this.submitMode = this.submitModeOptions.Add;
          this.dialogFormVisible = true;
          return;
        }
        this.submitMode = this.submitModeOptions.AddPayment;
        this.currentlyChosenAgenda = {};
        this.dialogFormVisible = true;
      }
    },
    onDateClick(arg) {
      if (this.userCanEditCalendar || this.userIsSupervisor) {
        this.currentlyChosenAgenda = arg;
        this.form.startDate = arg.date;
        // this.form.endDate = arg.date;
        // this.form.endDatePayment = arg.date;
        this.form.amount = arg.amount;
        if (this.calendarTitle == "Calendario de Facturación") {
          this.submitMode = this.submitModeOptions.Add;
          this.dialogFormVisible = true;
          return;
        }
        // this.submitMode = this.submitModeOptions.AddPayment;
        // this.dialogFormVisible = true;
      }
    },
    onEventClick(arg) {
      this.currentlyChosenAgenda = arg;
      this.form = {
        title: arg.event.title,
        description: arg.event.extendedProps.description,
        allDay: arg.event.allDay,
        paid: arg.event.extendedProps.paid,
        type: arg.event.extendedProps.type,
        startDate: arg.event.extendedProps.startDate,
        startTime: arg.event.extendedProps.startTime,
        endDate: arg.event.extendedProps.endDate, // "end" was being returned as null so a new endDate prop is being used
        endDatePayment: arg.event.extendedProps.endDate,
        amount: arg.event.extendedProps.amount,
        endTime: arg.event.extendedProps.endDate,
        color: arg.event.backgroundColor || "#F56C6C",
        agendaType: arg.event.extendedProps.agendaType,
        Time: arg.event.extendedProps.TimeEstimated,
        minutesHours: "m",
        fixed: arg.event.extendedProps.IsFixed,
        invoiceType: arg.event.extendedProps.invoiceType,
        SerieGroup: arg.event.extendedProps.SerieGroup
      };
      if (this.calendarTitle == "Calendario de Facturación") {
        this.submitMode = this.submitModeOptions.Edit;
        this.dialogFormVisible = true;
        return;
      }
      this.submitMode = this.submitModeOptions.EditPayment;
      this.dialogFormVisible = true;
    },
    onEventDrop(arg) {
      this.currentlyChosenAgenda = arg;

      this.form = {
        title: arg.event.title,
        description: arg.event.extendedProps.description,
        allDay: arg.event.allDay,
        paid: arg.event.paid,
        type: arg.event.type,
        startDate: arg.event.extendedProps.startDate,
        startTime: arg.event.extendedProps.startTime,
        endDate: arg.event.start,
        endDatePayment: arg.event.start,
        amount: arg.event.extendedProps.amount,
        endTime: arg.event.start,
        color: arg.event.backgroundColor || "#F56C6C",
        agendaType: arg.event.extendedProps.agendaType,
        Time: arg.event.extendedProps.TimeEstimated,
        minutesHours: "m",
        fixed: arg.event.extendedProps.IsFixed,
        invoiceType: arg.event.extendedProps.invoiceType,
        SerieGroup: arg.event.extendedProps.SerieGroup
      };
      if (this.calendarTitle == "Calendario de Facturación") {
        this.submitMode = this.submitModeOptions.Edit;
        this.dialogFormVisible = true;
        return;
      }
      this.submitMode = this.submitModeOptions.EditPayment;
      this.dialogFormVisible = true;
    },
    onDateSelect(arg) {
      if (this.userCanEditCalendar || this.userIsSupervisor) {
        this.currentlyChosenAgenda = arg;
        // this.form.startDate = arg.start;
        // this.form.endDate = arg.end;

        if (this.calendarTitle == "Calendario de Facturación") {
          this.submitMode = this.submitModeOptions.Add;
          this.dialogFormVisible = true;
          return;
        }
        // this.submitMode = this.submitModeOptions.AddPayment;
        // this.dialogFormVisible = true;
      }
    },

    // For the Super User Employee Dropdown
    formatArrayToElSelect,
    async loadEmployees() {
      let params = {
        Employeeid: this.currentUser.EmployeeId,
        CompanySelected: this.currentCompany
      };
      const { data } = await this.$http.get(
        "/api/CMI/Objetives/GetUsersObjetivos",
        {
          timeout: 3 * 60 * 1000,
          params
        }
      );
      this.employees = this.formatArrayToElSelect(data, {
        value: "EmployeeID",
        label: "Name"
      });
    },
    openCalendarDialog() {
      this.calendarFormVisible = true;
    },
    closeCalendarDialog() {
      this.calendarFormVisible = false;
      this.calendarForm.title = "";
      this.GetPersonalCalendario({
        employeeID: this.employeeId,
        invoiceType: this.invoiceType
      });
      this.getAllCalendarsForEmployee(this.employeeId);
      this.setPersonalCalendarAsCurrentlyChosen();
    },
    async submitCalendar() {
      await this.CreateCalendario({
        employeeID: this.currentUser.EmployeeId,
        calendarioTitle: this.calendarForm.title
      });
      this.closeCalendarDialog();
    },
    handleCloseDrawer() {
      this.openDrawer = false;
    },
    openCalendarDeleteDialog() {
      this.calendarDeleteDialogVisible = true;
    },
    closeCalendarDeleteDialog() {
      this.calendarDeleteDialogVisible = false;
    },
    async handleDeleteCalendar() {
      try {
        this.loading = true;
        let result = await this.DeleteCalendario({
          CalendarID: this.currentChosenCalendarID,
          EmployeeID: this.currentUser.EmployeeId
        });

        if (result.Succeded) {
          this.$message.success("Calendario eliminado exitosamente");
        } else if (result.CantRemovePersonal) {
          this.$message.error("No puede eliminar un calendario personal");
        } else if (result.BelongsToSomeoneElse) {
          this.$message.error("Este calendario fue creado por otra persona");
        }

        await this.getAllCalendarsForEmployee(this.employeeId);
        this.setPersonalCalendarAsCurrentlyChosen();
      } catch {
        this.loading = false;
        this.closeCalendarDeleteDialog();
      } finally {
        this.loading = false;
        this.closeCalendarDeleteDialog();
      }
    },
    ChangeCalendarResponsible() {
      //let calendarInfo = this.getCalendarFPsInfo;
      this.showResponsibleChanger = true;
    },
    OnChangeCalendarclose() {
      this.showResponsibleChanger = false;
    },
    async CalendarResponsibleUpdated(CalendarID) {
      this.showResponsibleChanger = false;
      await this.GetCalendario({
        calendarioID: CalendarID,
        invoiceType: this.invoiceType
      });
      await this.getAllCalendarsForEmployee(this.employeeId);
      this.RespImgUrl = this.getCalendarFPsInfo.Employee.imageUrl;
      this.RespName = this.getCalendarFPsInfo.Employee.FullName;
      this.CurrentResponsableInfo = this.getCalendarFPsInfo.Employee;
      this.CurrentCalendarInfo = this.getCalendarFPsInfo;
    },
    async GetCalendarTotalsSumaries(month, year) {
      const body = {
        params: {
          month: month, // this.CalendarMonth,
          year: year // this.CalendarYear
        }
      };
      await this.$http
        .get("/api/CalendarioFinanza/GetCalendarTotalsSumaries", body)
        .then((resp) => {
          this.CalendarTotalSumaries = resp.data;
        })
        .catch((error) => {
          console.error("Error al optener Totales de Calendarios: ", error);
        });
    },
    async GetWeeklyCollections() {
      await this.$http
        .get("/api/accountsReceivable/GetWeeklySalesCollected")
        .then((resp) => {
          this.CollectionByWeek = resp.data;
        })
        .catch((error) => {
          console.error("Error al optener Totales de Calendarios: ", error);
        });
    },
    setTotalLabelsAndAmounts(calendarId) {
      if (calendarId === 1) {
        this.TotalLabel = "Total de Facturas";
        this.TotalInvPay = this.CalendarTotalSumaries.filter(
          (calSum) => calSum.Description === "TotalInvoices"
        )[0].Amount;
        this.ExecutedLabel = "Facturas Ejecutadas";
        this.ExecutedInvPay = this.CalendarTotalSumaries.filter(
          (calSum) => calSum.Description === "ExecutedInvoices"
        )[0].Amount;
        this.PendingLabel = "Facturas Pendientes";
        this.PendingInvPay = this.CalendarTotalSumaries.filter(
          (calSum) => calSum.Description === "PendingInvoices"
        )[0].Amount;
        this.PayOneQuinceLabel = "Facturas Primera Quincena";
        this.PayOneQuinceInvPay = this.CalendarTotalSumaries.filter(
          (calSum) => calSum.Description === "FacPrimaryQuincePayments"
        )[0].Amount;
        this.PaySecondQuinceLabel = "Facturas Segunda Quincena";
        this.PaySecondQuinceInvPay = this.CalendarTotalSumaries.filter(
          (calSum) => calSum.Description === "FacSecondQuincePayments"
        )[0].Amount;
        this.PaymentFirstWeekLabel = "Facturas Semana 1";
        this.PaymentFirstWeekInvPay = this.CalendarTotalSumaries.filter(
          (calSum) => calSum.Description === "InvoicesFirstWeek"
        )[0].Amount;
        this.PaymentSecondWeekLabel = "Facturas Semana 2";
        this.PaymentSecondWeekInvPay = this.CalendarTotalSumaries.filter(
          (calSum) => calSum.Description === "InvoicesSecondWeek"
        )[0].Amount;
        this.PaymentThirdWeekLabel = "Facturas Semana 3";
        this.PaymentThirdWeekInvPay = this.CalendarTotalSumaries.filter(
          (calSum) => calSum.Description === "InvoicesThirdWeek"
        )[0].Amount;
        this.PaymentFourthWeekLabel = "Facturas Semana 4";
        this.PaymentFourthWeekInvPay = this.CalendarTotalSumaries.filter(
          (calSum) => calSum.Description === "InvoicesFourthWeek"
        )[0].Amount;
        this.PaymentFifthWeekLabel = "Facturas Semana 5";
        this.PaymentFifthWeekInvPay = this.CalendarTotalSumaries.filter(
          (calSum) => calSum.Description === "InvoicesFifthWeek"
        )[0].Amount;
      } else if (calendarId === 2) {
        this.TotalLabel = "Total de Pagos";
        this.TotalInvPay = this.CalendarTotalSumaries.filter(
          (calSum) => calSum.Description === "TotalPayments"
        )[0].Amount;
        this.ExecutedLabel = "Pagos Ejecutados";
        this.ExecutedInvPay = this.CalendarTotalSumaries.filter(
          (calSum) => calSum.Description === "ExecutedPayments"
        )[0].Amount;
        this.PendingLabel = "Pagos Pendientes";
        this.PendingInvPay = this.CalendarTotalSumaries.filter(
          (calSum) => calSum.Description === "PendingPayments"
        )[0].Amount;
        this.PayOneQuinceLabel = "Pagos Primera Quincena";
        this.PayOneQuinceInvPay = this.CalendarTotalSumaries.filter(
          (calSum) => calSum.Description === "PayPrimaryQuincePayments"
        )[0].Amount;
        this.PaySecondQuinceLabel = "Pagos Segunda Quincena";
        this.PaySecondQuinceInvPay = this.CalendarTotalSumaries.filter(
          (calSum) => calSum.Description === "PaySecondQuincePayments"
        )[0].Amount;
        this.PaymentFirstWeekLabel = "Pagos Semana 1";
        this.PaymentFirstWeekInvPay = this.CalendarTotalSumaries.filter(
          (calSum) => calSum.Description === "PaymentsFirstWeek"
        )[0].Amount;
        this.PaymentSecondWeekLabel = "Pagos Semana 2";
        this.PaymentSecondWeekInvPay = this.CalendarTotalSumaries.filter(
          (calSum) => calSum.Description === "PaymentsSecondWeek"
        )[0].Amount;
        this.PaymentThirdWeekLabel = "Pagos Semana 3";
        this.PaymentThirdWeekInvPay = this.CalendarTotalSumaries.filter(
          (calSum) => calSum.Description === "PaymentsThirdWeek"
        )[0].Amount;
        this.PaymentFourthWeekLabel = "Pagos Semana 4";
        this.PaymentFourthWeekInvPay = this.CalendarTotalSumaries.filter(
          (calSum) => calSum.Description === "PaymentsFourthWeek"
        )[0].Amount;
        this.PaymentFifthWeekLabel = "Pagos Semana 5";
        this.PaymentFifthWeekInvPay = this.CalendarTotalSumaries.filter(
          (calSum) => calSum.Description === "PaymentsFifthWeek"
        )[0].Amount;
      }

      this.CollectionFirstWeekLabel = "Cobrado Semana 1";
      this.CollectionFirstWeekInvPay = this.CollectionByWeek.filter(
        (calSum) => calSum.Week === "CollectionFirstWeek"
      )[0].Amount;
      this.CollectionSecondWeekLabel = "Cobrado Semana 2";
      this.CollectionSecondWeekInvPay = this.CollectionByWeek.filter(
        (calSum) => calSum.Week === "CollectionSecondWeek"
      )[0].Amount;
      this.CollectionThirdWeekLabel = "Cobrado Semana 3";
      this.CollectionThirdWeekInvPay = this.CollectionByWeek.filter(
        (calSum) => calSum.Week === "CollectionThirdWeek"
      )[0].Amount;
      this.CollectionFourthWeekLabel = "Cobrado Semana 4";
      this.CollectionFourthWeekInvPay = this.CollectionByWeek.filter(
        (calSum) => calSum.Week === "CollectionFourthWeek"
      )[0].Amount;
      this.CollectionFifthWeekLabel = "Cobrado Semana 5";
      this.CollectionFifthWeekInvPay = this.CollectionByWeek.filter(
        (calSum) => calSum.Week === "CollectionFifthWeek"
      )[0].Amount;
      this.TotalCollectionLabel = "Total Cobrado";
      this.TotalCollectionInvPay = this.CollectionByWeek.filter(
        (calSum) => calSum.Week === "TotalCollectionLastMonth"
      )[0].Amount;
    },
    async GetCalendarDate() {
      let calendarApi = this.$refs.fullCalendar.getApi();
      let actualSelectedDate = new Date(calendarApi.getDate());
      let month = actualSelectedDate.getMonth() + 1;
      let year = actualSelectedDate.getFullYear();
      this.CalendarMonth = month;
      this.CalendarYear = year;
      await this.GetWeeklyCollections();
      await this.GetCalendarTotalsSumaries(month, year);
    },
    onCalendarViewChange() {},
    async OnPrevMonthClick() {
      this.$refs.fullCalendar.getApi().prev();
      await this.GetCalendarDate();
      this.setTotalLabelsAndAmounts(this.currentChosenCalendarID);
    },
    async OnNextMonthClick() {
      this.$refs.fullCalendar.getApi().next();
      await this.GetCalendarDate();
      this.setTotalLabelsAndAmounts(this.currentChosenCalendarID);
    },
    async OnTodayMonthClick() {
      this.$refs.fullCalendar.getApi().today();
      await this.GetCalendarDate();
      this.setTotalLabelsAndAmounts(this.currentChosenCalendarID);
    },
    async OnPrevYearClick() {
      this.$refs.fullCalendar.getApi().prevYear();
      await this.GetCalendarDate();
      this.setTotalLabelsAndAmounts(this.currentChosenCalendarID);
    },
    async OnNextYearClick() {
      this.$refs.fullCalendar.getApi().nextYear();
      await this.GetCalendarDate();
      this.setTotalLabelsAndAmounts(this.currentChosenCalendarID);
    },
    handleTabClick() {},
    OnInvoiceTypeSelected(type) {
      this.invoiceType = type;
      this.GetCalendario({
        calendarioID: this.currentChosenCalendarID,
        invoiceType: this.invoiceType
      });
      // this.GetPersonalCalendario({employeeID: this.employeeId, invoiceType: this.invoiceType});
      // this.getAllCalendarsForEmployee(this.employeeId);
      // this.setPersonalCalendarAsCurrentlyChosen();
    },
    async ChangingCalendar(newCalendarID) {
      let actualDate = new Date();
      await this.GetCalendarTotalsSumaries(
        actualDate.getMonth() + 1,
        actualDate.getFullYear()
      );
      await this.GetWeeklyCollections();
      this.setTotalLabelsAndAmounts(newCalendarID);
      if (newCalendarID) {
        await this.GetCalendario({
          calendarioID: newCalendarID,
          invoiceType: this.invoiceType
        });
        //await this.GetCalendarTotalsSumaries(5, 2024)
        //this is to calculate the records sum of amount
        // this.recordsTotal =
        //   this.$store.getters["calendarFinances/events"].length;

        // //this is to calculate the total sum of amount
        // let sum = 0;
        // this.$store.getters["calendarFinances/events"].forEach((event) => {
        //   sum += event.amount;
        // });
        // this.amountTotal = formatMonto(sum);

        if (this.calendarIsPersonal) {
          // If the calendar is personal, get the Tasks of the owner of that calendar
          let calendarCreator = this.listOfCalendarsForUser.find(
            (cal) => cal.ID == newCalendarID
          ).CreatedBy;
          await this.initTasks(calendarCreator);
        }
      }
      this.RespImgUrl = this.getCalendarFPsInfo.Employee.imageUrl;
      this.RespName = this.getCalendarFPsInfo.Employee.FullName;
      this.CurrentResponsableInfo = this.getCalendarFPsInfo.Employee;
      this.CurrentCalendarInfo = this.getCalendarFPsInfo;
      //await this.GetCalendarTotalsSumaries(5, 2024)
      this.GetCalendarDate();
    }
  },
  watch: {
    employeeId: async function (newEmployeeId, oldEmployeeId) {
      // When the Super User changes the employee in the dropdown, it will make an API call to return calendars belonging to the new employee
      // Prevents this from firing on the first change when the page loads. This was causing Events and Tasks to be initialized again after "Created" changed the employee ID
      // Prevents error when selection is cleared
      if (oldEmployeeId > 0 && newEmployeeId > 0) {
        // Get UserID with the EmployeeID
        const newUserApiCall = await this.$http.get(
          "/api/Employees/" + newEmployeeId
        );
        const newUserId = newUserApiCall.data.UserID;
        this.userId = newUserId;

        await this.GetPersonalCalendario({
          employeeID: this.employeeId,
          invoiceType: this.invoiceType
        });
        await this.getAllCalendarsForEmployee(this.employeeId);
        await this.setPersonalCalendarAsCurrentlyChosen();
      }
    },
    currentChosenCalendarID: async function (newCalendarID) {
      await this.ChangingCalendar(newCalendarID);
    }
  }
};
</script>

<style scoped>
.fc-event-resizer.fc-event-resizer-end {
  /* Disables resizing in Week and Day view */
  display: none !important;
}
.fc .fc-col-header-cell-cushion {
  color: #403d3d;
}
.fc .fc-daygrid-day-number {
  color: #403d3d;
}
.fc-daygrid-dot-event .fc-event-title {
  color: #403d3d;
}
.fc .fc-button {
  color: #403d3d !important;
  border-color: #403d3d !important;
}
/* .card-base {
  background-color: rgba(160, 220, 200, 0.397);
} */
.el-avatar--large {
  width: 100px;
  height: 100px;
  line-height: 40px;
}

.boldedWord {
  font-weight: bold;
  font-size: x-large;
}

.textBold {
  font-weight: bold;
}
.rowTotals {
  margin-bottom: 0px;
}

.IsRed.is-disabled ::v-deep .el-input__inner {
  color: #ef4444;
  border-color: #ef4444;
  background-color: #f9fafb;
  -webkit-text-fill-color: #ef4444;
}
</style>
